import { isFeatureEnabled } from 'owa-feature-flags';
import { isBrowserChrome, isBrowserFirefox, isMac, isWindows } from 'owa-user-agent';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getOwaWorkload, OwaWorkload } from 'owa-workloads';

export const isWebPushNotificationSupported = (windowObj: Window) =>
    (isFeatureEnabled('fwk-webPushNotification') ||
        isFeatureEnabled('fwk-webPushNotificationV2')) &&
    windowObj.navigator &&
    windowObj.navigator.serviceWorker != null &&
    windowObj.PushManager != null &&
    ((isMac() || isWindows()) && (isBrowserChrome() || isBrowserFirefox())) &&
    !getUserConfiguration().SessionSettings.IsUserCultureRightToLeft &&
    getOwaWorkload() == OwaWorkload.Mail;
